import { CampaignsContext } from "contexts/Campaigns";
import { SavedBrandCollectionsContext } from "contexts/SavedBrandCollections";
import { Dispatch, SetStateAction, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "schemas/routes";

import ConfirmDialog from "components/Dialogs/ConfirmDialog";

interface Props {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  campaignId: number;
}

const DeleteCampaignDialog = ({ open, setOpen, campaignId }: Props) => {
  const navigate = useNavigate();
  const { deleteCampaign } = useContext(CampaignsContext);
  const { refreshSavedList } = useContext(SavedBrandCollectionsContext);
  const [deleteLoading, setDeleteLoading] = useState<boolean>(false);

  const handleConfirm = async () => {
    setDeleteLoading(true);
    await deleteCampaign(campaignId);
    await refreshSavedList();
    setOpen(false);
    setDeleteLoading(false);
    navigate(`/${routes.campaignView}`);
  };

  return (
    <ConfirmDialog
      header={`Delete this campaign?`}
      subheader={`It appears no brands in this campaign suit your needs. Do you want to delete this campaign instead?`}
      open={open}
      handleClose={() => setOpen(false)}
      handleConfirm={handleConfirm}
      loading={deleteLoading}
    />
  );
};

export default DeleteCampaignDialog;
